<div class="form-field">
  <span class="form-field-label">
    {{ label }}<span *ngIf="required" class="required"> *</span>
  </span>
  <mat-select
    [formControl]="form"
    [placeholder]="placeholder"
    (selectionChange)="onChange()"
  >
    <mat-option *ngIf="cancel" [value]="null">{{ cancel }}</mat-option>
    <mat-option
      *ngFor="let option of options"
      [value]="option.value ?? option.name"
    >
      {{ option.name }}
    </mat-option>
  </mat-select>
</div>
<ng-container *ngIf="form.invalid && (form.dirty || form.touched)">
  <mat-error *ngIf="form.hasError('required')">{{ placeholder }}</mat-error>
</ng-container>
